import { render, staticRenderFns } from "./PreviewDropZone.vue?vue&type=template&id=cf921636&"
import script from "./PreviewDropZone.vue?vue&type=script&lang=js&"
export * from "./PreviewDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports